"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AttachmentFormatter;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Fullscreen2 = _interopRequireDefault(require("@material-ui/icons/Fullscreen"));

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _Add2 = _interopRequireDefault(require("@material-ui/icons/Add"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

AttachmentFormatter.propTypes = _propTypes.EditorProps;

function AttachmentFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column,
      isCellSelected = _ref.isCellSelected;
  var key = column.key,
      onClickAdd = column.onClickAdd;
  var value = row[key] || [];

  var handleAdd = function handleAdd(e) {
    if (typeof onClickAdd === "function") {
      onClickAdd({
        row: row,
        column: column,
        currentTarget: e.currentTarget,
        variant: "add"
      });
    }
  };

  var handleExpand = function handleExpand(e) {
    if (typeof onClickAdd === "function") {
      onClickAdd({
        row: row,
        column: column,
        currentTarget: e.currentTarget,
        variant: "expand"
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex",
    alignItems: "center",
    style: {
      height: "100%",
      position: "relative"
    },
    onClick: value.length === 0 && isCellSelected ? handleAdd : null
  }, isCellSelected ? /*#__PURE__*/_react["default"].createElement(_Button2["default"], {
    variant: "contained",
    style: {
      display: "flex",
      alignItems: "center",
      borderRadius: 4,
      marginRight: 3,
      marginLeft: -2,
      padding: 0,
      minWidth: 18
    }
  }, /*#__PURE__*/_react["default"].createElement(_Add2["default"], {
    onClick: handleAdd,
    style: {
      fontSize: 16
    }
  })) : null, value.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      style: {
        border: "2px solid rgba(209, 213, 219,1)",
        borderRadius: "0.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        height: 25,
        marginRight: 3,
        minWidth: 25
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: item.url,
      alt: item.fileName,
      style: {
        maxHeight: "100%",
        borderRadius: "0.25rem"
      }
    }));
  }), isCellSelected && value.length > 0 ? /*#__PURE__*/_react["default"].createElement(_Button2["default"], {
    color: "primary",
    variant: "contained",
    style: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: "#0073ea",
      borderRadius: 4,
      position: "absolute",
      right: 0,
      top: 7,
      zIndex: 1,
      minWidth: "auto",
      padding: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_Fullscreen2["default"], {
    onClick: handleExpand,
    style: {
      fontSize: 16,
      color: "white"
    }
  })) : null);
}